import {PaymentMethod} from "../../models/PaymentMethod";


let paymentMethodsApi = {
    async get(token, companyId, params={}){
        let response = await window.axios.get('/api/payment-methods', {
            params:{
                api_token:token,
                company_logged:companyId,
                ...params
            }
        });
        return response.data.map(l=>new PaymentMethod(l));
    },
    async delete(token, companyId, id){
        let response = await window.axios.delete('/api/payment-methods/'+id, {
            params: {
           
                api_token:token,
                company_logged:companyId,
            }
                
            
        });
        return response.data.map(l=>new PaymentMethod(l));
    },
    async pullFromErp(token, companyId){
        let response = await window.axios.post('/api/payment-methods/pull-from-erp', null,{
            params:{
                api_token:token,
                company_logged:companyId
            }
        });
        return response.data.success;
    }
}

export default paymentMethodsApi